import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const Loading = ({
  isDesktop,
  isLeaderBoardPage,
  isLeaderBoardChristmasPage,
}: {
  isDesktop: boolean;
  isLeaderBoardPage?: boolean;
  isLeaderBoardChristmasPage?: boolean;
}) => {
  return isDesktop ? (
    <div
      className={`flex ${isLeaderBoardPage || isLeaderBoardChristmasPage ? "h-[78px]" : "h-[60px]"} px-[1.5rem] relative mainSection mx-auto border-b-[1px] border-solid border-[#ccc]`}>
      <Skeleton
        count={2}
        inline
        highlightColor="#fff"
        containerClassName="flex justify-start items-center gap-4 w-[40%]"
      />
      <Skeleton count={1} inline highlightColor="#fff" containerClassName="m-auto w-[120px]" />
      <Skeleton
        count={3}
        inline
        highlightColor="#fff"
        containerClassName="flex gap-4 items-center justify-end w-[40%]"
      />
    </div>
  ) : (
    <div className="flex items-center h-[57px] px-3 justify-between border-b-[1px] border-solid border-[#ccc] header-container">
      <Skeleton count={2} inline highlightColor="#fff" containerClassName="flex gap-1 w-[108px]" />
      <Skeleton count={2} inline highlightColor="#fff" containerClassName="gap-3 flex items-center w-[56px]" />
    </div>
  );
};
